import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';

const STEPS = [
  { id: 1, label: 'Moto' },
  { id: 2, label: 'Aportes' },
  { id: 3, label: 'Deuda' },
  { id: 4, label: 'Color' },
  { id: 5, label: 'Documentos' }
];

export default function WizardStepper({ currentStep }) {
  return (
    <div className="w-full py-6" data-testid="wizard-stepper">
      <div className="flex items-center justify-between max-w-2xl mx-auto">
        {STEPS.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center">
              <div className="relative">
                {step.id < currentStep ? (
                  <CheckCircle2 className="w-10 h-10 text-[#10B981]" data-testid={`step-${step.id}-completed`} />
                ) : step.id === currentStep ? (
                  <div 
                    className="w-10 h-10 rounded-full border-4 border-[#F5A623] bg-[#1A1A1A] flex items-center justify-center"
                    data-testid={`step-${step.id}-active`}
                  >
                    <span className="text-[#F5A623] font-bold">{step.id}</span>
                  </div>
                ) : (
                  <Circle className="w-10 h-10 text-[#666666]" data-testid={`step-${step.id}-upcoming`} />
                )}
              </div>
              <span className={`mt-2 text-xs ${
                step.id === currentStep ? 'text-[#F5A623] font-semibold' : 
                step.id < currentStep ? 'text-[#10B981]' : 'text-[#666666]'
              }`}>
                {step.label}
              </span>
            </div>
            {index < STEPS.length - 1 && (
              <div className={`flex-1 h-1 mx-2 ${
                step.id < currentStep ? 'bg-[#10B981]' : 'bg-[#666666]'
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}